'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _TextField = require('material-ui/TextField');

var _TextField2 = _interopRequireDefault(_TextField);

var _FlatButton = require('material-ui/FlatButton');

var _FlatButton2 = _interopRequireDefault(_FlatButton);

var _FontIcon = require('material-ui/FontIcon');

var _FontIcon2 = _interopRequireDefault(_FontIcon);

var _i18n = require('../../util/i18n');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var _class = function (_React$Component) {
  _inherits(_class, _React$Component);

  function _class(props, context) {
    _classCallCheck(this, _class);

    var _this = _possibleConstructorReturn(this, (_class.__proto__ || Object.getPrototypeOf(_class)).call(this, props, context));

    _this.state = {
      currentView: 0,
      errorText: null,
      value: props.groups[0].title
    };
    _this.renderButton = _this.renderButton.bind(_this);
    _this.renderView = _this.renderView.bind(_this);
    _this.setView = _this.setView.bind(_this);
    _this.handleTextChange = _this.handleTextChange.bind(_this);
    return _this;
  }

  _createClass(_class, [{
    key: 'setView',
    value: function setView(e) {
      var index = Number(e.currentTarget.dataset.index);
      this.setState({
        currentView: index,
        errorText: null,
        value: this.props.groups[index].title
      });
    }
  }, {
    key: 'handleTextChange',
    value: function handleTextChange(event, value) {
      var _this2 = this;

      var found = false;
      this.props.groups.forEach(function (group, index) {
        if (String(group.title) === value) {
          found = true;
          _this2.setState({
            currentView: index,
            errorText: null,
            value: value
          });
        }
      });
      if (!found && value !== '') {
        this.setState(_extends(this.state, {
          errorText: _i18n.invalidValueText,
          value: value
        }));
      } else if (!found && value === '') {
        this.setState(_extends(this.state, {
          errorText: null,
          value: value
        }));
      }
    }
  }, {
    key: 'renderButton',
    value: function renderButton() {
      var index = this.state.currentView;
      var groups = this.props.groups;
      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(_FlatButton2.default, {
          icon: _react2.default.createElement(
            _FontIcon2.default,
            { className: 'material-icons' },
            'keyboard_arrow_left'
          ),
          onTouchTap: this.setView,
          disabled: index === 0 || this.state.errorText,
          'data-index': index - 1,
          secondary: true
        }),
        _react2.default.createElement(_TextField2.default, {
          style: { display: 'inline-block', width: '88px' },
          inputStyle: { textAlign: 'center' },
          hintStyle: { textAlign: 'center' },
          value: this.state.value,
          errorText: this.state.errorText,
          onChange: this.handleTextChange
        }),
        _react2.default.createElement(_FlatButton2.default, {
          icon: _react2.default.createElement(
            _FontIcon2.default,
            { className: 'material-icons' },
            'keyboard_arrow_right'
          ),
          onTouchTap: this.setView,
          disabled: index === groups.length - 1 || this.state.errorText,
          'data-index': index + 1,
          secondary: true
        })
      );
    }
  }, {
    key: 'renderView',
    value: function renderView(views) {
      var _this3 = this;

      var result = void 0;
      var i = Number(this.state.currentView);
      if (views[i]) {
        (function () {
          var _props = _this3.props,
              groups = _props.groups,
              others = _objectWithoutProperties(_props, ['groups']);

          if (Array.isArray(views[i].element)) {
            result = views[i].element.map(function (item) {
              return _react2.default.cloneElement(item, _extends({}, others));
            });
          } else {
            result = _react2.default.cloneElement(views[i].element, _extends({}, others));
          }
        })();
      }
      return result;
    }
  }, {
    key: 'render',
    value: function render() {
      var groups = this.props.groups;

      return _react2.default.createElement(
        'div',
        null,
        _react2.default.createElement(
          'div',
          { style: { textAlign: 'center' } },
          this.renderButton()
        ),
        this.renderView(groups)
      );
    }
  }]);

  return _class;
}(_react2.default.Component);

_class.propTypes = {
  groups: _react2.default.PropTypes.array.isRequired
};
_class.defaultProps = {
  groups: []
};
exports.default = _class;


/*****************
 ** WEBPACK FOOTER
 ** ./~/@its/components/lib/Presentational components/ViewGroup/ViewGroup.js
 ** module id = 506
 ** module chunks = 0
 **/